import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextRegular12, TextRegular14 } from 'styles/typography';
import { Card, Col, Row, Divider } from 'antd';

interface IProps {
  cultureName?: string;
  sowingStart: Date | null;
  sowingEnd: Date | null;
  area: number | string;
}

export default function CultureDetailsCard({
  cultureName,
  sowingStart,
  sowingEnd,
  area,
}: IProps) {
  const { t } = useTranslation();

  return (
    <Card bordered={false}>
      <Row>
        <Col span={12}>
          <TextRegular14>
            {t('Cultures.Details.DetailsCard.Culture', 'Culture')}
          </TextRegular14>
        </Col>

        <Col span={12}>
          <TextRegular12>{cultureName}</TextRegular12>
        </Col>
      </Row>

      {area !== undefined && (
        <>
          <Divider dashed />
          <Row>
            <Col span={12}>
              <TextRegular14>
                {t('Cultures.Details.DetailsCard.Area', 'Area')}
              </TextRegular14>
            </Col>

            <Col span={12}>
              <TextRegular12>{area}</TextRegular12>
            </Col>
          </Row>
        </>
      )}

      {sowingStart && (
        <>
          <Divider dashed />
          <Row>
            <Col span={12}>
              <TextRegular14>
                {t(
                  'Cultures.Details.DetailsCard.StartOfSowing',
                  'Start of sowing',
                )}
              </TextRegular14>
            </Col>

            <Col span={12}>
              <TextRegular12>{sowingStart}</TextRegular12>
            </Col>
          </Row>
        </>
      )}

      {sowingEnd && (
        <>
          <Divider dashed />
          <Row>
            <Col span={12}>
              <TextRegular14>
                {t('Cultures.Details.DetailsCard.EndOfSowing', 'End of sowing')}
              </TextRegular14>
            </Col>

            <Col span={12}>
              <TextRegular12>{sowingEnd}</TextRegular12>
            </Col>
          </Row>
        </>
      )}
    </Card>
  );
}
